import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Component style
import './TweetsContainer.scss';

// Components
import TweetCard from '../tweetCard/TweetCard';

// Utils, const & misc
import {ApiGetJSON} from '../../../utils/httpUtils';

class TweetsContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoadingStatus: true,
			isLoadingHeaderData: true,
			tweetsData: null,
			profileData: null,
			statusFetchError: null,
		};
	}

	// Load content on component mounted
	componentDidMount(){
		this.loadTweets();
		this.loadProfileInfo();
	}

	/**
	 * Load profile info
	 */
	loadProfileInfo = () => {
		ApiGetJSON(
			`users/show.json`,
			{
				screen_name: this.props.twitterUser
			},
			(jsonResult) => {
				this.setState({
					profileData: jsonResult,
					isLoadingHeaderData: false,
					// statusFetchError: null
				});
			},
			(errorMessage) => {
				this.setState({
					isLoadingHeaderData: false,
					// statusFetchError: e.target.responseText || `Error ${e.target.status}`,
				});
			}
		);
	};

	/**
	 * Load tweets using XHR
	 */
	loadTweets = () => {
		ApiGetJSON(
			`statuses/user_timeline.json`,
			{
				count: this.props.maxTweets,
				screen_name: this.props.twitterUser
			},
			(jsonResult) => {
				this.setState({
					tweetsData: jsonResult,
					isLoadingStatus: false,
					statusFetchError: null
				});
			},
			(errorMessage) => {
				this.setState({
					isLoadingStatus: false,
					statusFetchError: errorMessage
				});
			}
		);
	};

	refreshTweets = () => {
		this.setState({
			isLoadingStatus: true,
			statusFetchError: null,
			tweetsData: null
		});
		this.loadTweets();
	};

	/**
	 * Render content depending on whether it is loading, has triggered an error or if we have some data
	 * @return {*} React object
	 */
	renderContent = () => {
		if( this.state.isLoadingStatus )
			return (
				<div className={`tweetsLoader`}>
					<svg className="tweetsLoader__Spinner" viewBox="0 0 50 50">
						<circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
					</svg>
				</div>
			);

		if( this.state.statusFetchError ){
			return (
				<div className={`tweetsLoadingError`}>
					<h3 className={`tweetsLoadingError__title`}>Something went wrong...</h3>
					<p>
						Sorry, we were not able to load tweets for {this.props.twitterUser}
					</p>
				</div>
			)
		}

		if( this.state.tweetsData && this.state.tweetsData.length > 0 ){
			return(
				<div className={`tweetsList`}>
					{
						this.state.tweetsData.map((val,index) => (<TweetCard
							key={index}
							tweetData={val}
							twitterUser={this.props.twitterUser}
						/>))
					}
				</div>
			)

		} else {
			return (
				<div className={`tweetsEmpty`}>
					<h3 className={`tweetsEmpty__title`}>No tweets to show</h3>
				</div>
			)
		}
	};

	/**
	 *	Render Header
	 */
	renderHeader = () => {
		return (
			<>
				<div className="tweetsHeader__imageContainer">
					{
						this.state.profileData ? (
							<img
								src={ this.state.profileData.profile_image_url}
								className="tweetsHeader__image"
								alt={this.state.profileData.name}
							/>
						) : (<></>)
					}

				</div>
				<div className="tweetsHeader__profileName">
					{this.state.profileData ? this.state.profileData.name : '...'}
				</div>
			</>
		)
	};

	render() {
		return (
			<div className={`tweetsContainer`}>
				<div className="tweetsHeader">
					<button
						className="tweetsHeader__refreshButton"
						onClick={() => {
							this.refreshTweets()
						}}
						disabled={this.state.isLoadingStatus}
					/>
					{
						this.renderHeader()
					}
				</div>
				<div className="tweetsListContainer">
					{
						this.renderContent()
					}
				</div>
			</div>
		);
	}
}

TweetsContainer.propTypes = {
	twitterUser: PropTypes.string.isRequired
};

export default TweetsContainer;
